import script from "./ListaEncontrosAdicionados.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaEncontrosAdicionados.vue?vue&type=script&setup=true&lang=js"

import "./ListaEncontrosAdicionados.vue?vue&type=style&index=0&id=e3f4b824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f4b824"]])

export default __exports__